import { useState, useParams, FaEye, ToastContainer, FaArrowAltCircleRight, FaEyeSlash } from '../../common/common';
import Select from 'react-select';
import { useErrorContext } from '../../context/ErrorContext';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import MidAddUsers from '../../middleware/Users/MidAddUsers';
import { BiBuildings, BiEnvelope, BiLock, BiMailSend, BiMap, BiPhone, BiPhoneCall } from 'react-icons/bi';

import Navigations from '../../common/useNavigation';


const AddUser = () => {

  const { navigatePlans , navigateViewUser } = Navigations();
  const { type } = useParams();
  const [issidebarOpen, setIssidebarOpen] = useState(true);
  const { error } = useErrorContext();

  const { users, userPlan, Remainuser,
    handleSubmit,
    values,
    handlesetusertype,
    countryData,
    stateData,
    cityData,
    handleGetState,
    handleGetCities,
    handleSetCityId,
    userTypes,
    handleChange, handleGetWorkState, handleGetWorkCities, handleSetWorkCityId } = MidAddUsers();


  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);


  // Rest of your existing code...
  const toggleSidebar = () => setIssidebarOpen(!issidebarOpen);
  const userDetails = users?.[0] || {};
  const {
    AppID,
    ProfilePic,
    UserType: usertype,
    FullName: username,
  } = userDetails;


  if (Array.isArray(userPlan) && userPlan.length > 0) {
    var planID = userPlan[0]['plan_id'];
  }
  return (
    <div className="md:flex md:flex-row md:w-full">
      <div className={`${issidebarOpen ? 'w-0 md:w-1/5' : 'w-0'}`}>
        <Sidebar
          handleSideBar={toggleSidebar}
          issidebarOpen={issidebarOpen}
          UserTypeData={usertype}
          userName={username}
          appID={AppID}
          profilePic={ProfilePic}
          currentUserType={type}
          currentplan={planID}
          ActiveUser={users[0]?.Status}
        />
      </div>
      <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'}`}>
        <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
        <div className="grid grid-cols-12">
          <div className="col-start-1 col-end-13">
            <div className="p-4 text-xl text-[#1e3a8a]">
              <div className='px-3'>
                <h1 className='text-lg text-theme-color-text font-bold'>Users</h1>
                <p className='text-gray-600 text-[16px]'>
                  Select attributes as per your products range. Code, name and category are required attributes.
                </p>
              </div>
            </div>
          </div>
        </div>

        {users[0]?.Status === 1 ? (
          <div>
            {Remainuser > 0 ?
              <div className="grid grid-cols-12">
                <div className="col-start-1 col-end-13">
                  <div className="border-0 flex-row rounded-xl  bg-white shadow-xs">
                    <form  className="mt-2">
                      <div className="border-0 rounded-lg md:rounded-xl m-1 md:m-3 bg-white shadow-xs">
                        <div className='relative flex flex-col min-w-0 break-words'>
                          <div className='p-2 md:p-3'>
                            <div className="border-0 rounded-lg md:rounded-xl m-1 md:m-3 bg-white shadow-xs container">
                              <div className='relative flex flex-col min-w-0 break-words'>
                                <div className='p-2 md:p-3'>
                                  <div className='flex flex-col md:flex-row justify-between items-start md:items-center mb-3 md:mb-4'>
                                    <h5 className="capitalize text-lg md:text-xl font-bold mb-2 md:mb-0">Add User</h5>

                                    <button type="button" className="relative rounded-md group px-3 h-10 md:h-12 mt-0 md:mt-5 flex space-x-2 items-center bg-button-color hover:bg-button-color w-full md:w-[250px]" onClick={navigateViewUser}>
                                      <span className="relative text-sm md:text-md text-black font-semibold pl-0">View All Users</span>
                                      <div className="flex items-center h-10 w-10 md:h-12 md:w-12 rounded-full bg-button-color absolute right-[0px] drop-shadow-2xl">
                                        <FaEye className="h-3 w-3 text-black translate-x-4 transition duration-100 group-hover:scale-[2]" />
                                      </div>
                                    </button>
                                  </div>
                                  <form onSubmit={handleSubmit} >
                                    <div className='bg-white relative border-[1px] border-solid border-[#e5e5e5] rounded-md my-2'>
                                      <div>
                                        <div className='flex flex-row justify-between items-center py-3 bg-[#e9f3fe]'>
                                          <h5 className="text-black capitalize text-md font-semibold mx-3">Personal & contact Details </h5>
                                        </div>
                                        <div className="py-5 px-3">
                                          <div className=" space-y-4">
                                            <div className=" rounded-lg  w-full ">
                                              <div className="grid grid-cols-1 md:grid-cols-5 gap-4 text-sm">
                                                {/* Data Section */}
                                                <div className="form-group">
                                                  <label className="text-sm font-medium text-gray-700 mb-1">User Type  </label>
                                                  <label className="text-sm font-medium text-red-700">*</label>
                                                  <Select
                                                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); } }}
                                                    options={userTypes}
                                                    placeholder="Select User Type"
                                                    onChange={handlesetusertype}
                                                    className={`react-select-container ${error.userType ? 'react-select--error' : ''}`}
                                                    classNamePrefix="react-select"
                                                  />
                                                  {error.userType && <p className="mt-1 text-sm text-red-600">{error.userType}</p>}
                                                </div>
                                                <div className="">
                                                  <label className="text-sm font-medium text-gray-700 mb-1">Full Name</label>
                                                  <label className="text-sm font-medium text-red-700">*</label>
                                                  <div className="relative">
                                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                      <BiBuildings className="text-gray-400" />
                                                    </div>
                                                    <input

                                                      type="text"
                                                      name="fullName"
                                                      className={`pl-10 py-2 w-full rounded-md border ${error.fullName ? 'border-red-300' : 'border-gray-300'} focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500`}
                                                      placeholder="Enter Manager Full Name"
                                                      value={values.fullName}
                                                      onChange={handleChange}
                                                    />
                                                  </div>
                                                  {error.fullName && <p className="mt-1 text-sm text-red-600">{error.fullName}</p>}
                                                </div>
                                                <div className="form-group">
                                                  <label className="text-sm font-medium text-gray-700 mb-1">Mobile Number</label>
                                                  <label className="text-sm font-medium text-red-700">*</label>
                                                  <div className="relative">
                                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                      <BiPhone className="text-gray-400" />
                                                    </div>
                                                    <input
                                                      type="tel"
                                                      name="primaryNumber"
                                                      className={`pl-10 py-2 w-full rounded-md border ${error.primaryNumber ? 'border-red-300' : 'border-gray-300'} focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500`}
                                                      placeholder="Enter Mobile No"
                                                      value={values.primaryNumber}
                                                      onChange={handleChange}
                                                    />
                                                  </div>
                                                  {error.primaryNumber && <p className="mt-1 text-sm text-red-600">{error.primaryNumber}</p>}
                                                </div>
                                                <div className="form-group">
                                                  <label className="text-sm font-medium text-gray-700 mb-1">Other Mobile Number </label>
                                                  <div className="relative">
                                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                      <BiPhoneCall className="text-gray-400" />
                                                    </div>
                                                    <input
                                                      type="tel"
                                                      name="secondaryNumber"
                                                      className={`pl-10 py-2 w-full rounded-md border border-gray-300 focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500`}
                                                      placeholder="Enter Secondary Number"
                                                      value={values.secondaryNumber}
                                                      onChange={handleChange}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="form-group">
                                                  <label className="text-sm font-medium text-gray-700 mb-1">Email Address </label>
                                                  <label className="text-sm font-medium text-red-700">*</label>
                                                  <div className="relative">
                                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                      <BiEnvelope className="text-gray-400" />
                                                    </div>
                                                    <input
                                                      type="email"
                                                      name="emailAddress"
                                                      className={`pl-10 py-2 w-full rounded-md border ${error.emailAddress ? 'border-red-300' : 'border-gray-300'} focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500`}
                                                      placeholder="Enter Manager Email"
                                                      value={values.emailAddress}
                                                      onChange={handleChange}
                                                    />
                                                  </div>
                                                  {error.emailAddress && <p className="mt-1 text-sm text-red-600">{error.emailAddress}</p>}
                                                </div>

                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='bg-white relative border-[1px] border-solid border-[#e5e5e5] rounded-md my-2'>
                                      <div>
                                        <div className='flex flex-row justify-between items-center py-3 bg-[#e9f3fe]'>
                                          <h5 className="text-black capitalize text-md font-semibold mx-3">Residential Address Details </h5>
                                        </div>
                                        <div className="py-5 px-3">
                                          <div className=" space-y-4">
                                            <div className=" rounded-lg  w-full ">
                                              <div className="grid grid-cols-1 md:grid-cols-5 gap-4 text-sm">
                                                {/* Data Section */}
                                                <div className="form-group">
                                                  <label className="text-sm font-medium text-gray-700 mb-1">Full Address </label>
                                                  <label className="text-sm font-medium text-red-700">*</label>
                                                  <div className="relative">
                                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                      <BiMap className="text-gray-400" />
                                                    </div>
                                                    <input
                                                      type="text"
                                                      name="address"
                                                      className={`pl-10 py-2 w-full rounded-md border ${error.address ? 'border-red-300' : 'border-gray-300'} focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500`}
                                                      placeholder="Enter Manager Address"
                                                      value={values.address}
                                                      onChange={handleChange}
                                                    />
                                                  </div>
                                                  {error.address && <p className="mt-1 text-sm text-red-600">{error.address}</p>}
                                                </div>

                                                <div className="form-group">
                                                  <label className="text-sm font-medium text-gray-700 mb-1">Country </label>
                                                  <label className="text-sm font-medium text-red-700">*</label>
                                                  <Select
                                                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); } }}
                                                    options={countryData}
                                                    placeholder="Select Country"
                                                    onChange={handleGetState}
                                                    className={`react-select-container ${error.selectedCountryId ? 'react-select--error' : ''}`}
                                                    classNamePrefix="react-select"
                                                  />
                                                  {error.selectedCountryId && <p className="mt-1 text-sm text-red-600">{error.selectedCountryId}</p>}
                                                </div>
                                                <div className="form-group">
                                                  <label className="text-sm font-medium text-gray-700 mb-1">State/Province </label>
                                                  <label className="text-sm font-medium text-red-700">*</label>
                                                  <Select
                                                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); } }}
                                                    options={stateData}
                                                    placeholder="Select State"
                                                    onChange={handleGetCities}
                                                    className={`react-select-container ${error.selectedStateId ? 'react-select--error' : ''}`}
                                                    classNamePrefix="react-select"
                                                  />
                                                  {error.selectedStateId && <p className="mt-1 text-sm text-red-600">{error.selectedStateId}</p>}
                                                </div>
                                                <div className="form-group">
                                                  <label className="text-sm font-medium text-gray-700 mb-1">City </label>
                                                  <label className="text-sm font-medium text-red-700">*</label>
                                                  <Select
                                                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); } }}
                                                    options={cityData}
                                                    placeholder="Select City"
                                                    onChange={handleSetCityId}
                                                    className={`basic-single react-select-container ${error.selectedCityId ? 'react-select--error' : ''}`}
                                                    classNamePrefix="react-select"
                                                  />
                                                  {error.selectedCityId && <p className="mt-1 text-sm text-red-600">{error.selectedCityId}</p>}
                                                </div>
                                                <div className="form-group">
                                                  <label className="text-sm font-medium text-gray-700 mb-1">Postal Code </label>
                                                  <label className="text-sm font-medium text-red-700">*</label>
                                                  <div className="relative">
                                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                      <BiMailSend className="text-gray-400" />
                                                    </div>
                                                    <input
                                                      type="text"
                                                      name="pincode"
                                                      className={`pl-10 py-2 w-full rounded-md border ${error.pincode ? 'border-red-300' : 'border-gray-300'} focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500`}
                                                      placeholder="Enter Pincode / Zipcode"
                                                      value={values.pincode}
                                                      onChange={handleChange}
                                                    />
                                                  </div>
                                                  {error.pincode && <p className="mt-1 text-sm text-red-600">{error.pincode}</p>}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='bg-white relative border-[1px] border-solid border-[#e5e5e5] rounded-md my-2'>
                                      <div>
                                        <div className='flex flex-row justify-between items-center py-3 bg-[#e9f3fe]'>
                                          <h5 className="text-black capitalize text-md font-semibold mx-3">Work Address Details </h5>
                                        </div>

                                        <div className="py-5 px-3">
                                          <div className=" space-y-4">
                                            <div className=" rounded-lg  w-full ">
                                              <div className="grid grid-cols-1 md:grid-cols-5 gap-4 text-sm">
                                                {/* Data Section */}
                                                <div className="form-group">
                                                  <label className="text-sm font-medium text-gray-700 mb-1">Area / Group / Village</label>
                                                  <label className="text-sm font-medium text-red-700">*</label>
                                                  <div className="relative">
                                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                      <BiMap className="text-gray-400" />
                                                    </div>
                                                    <input
                                                      type="text"
                                                      name="area"
                                                      className={`pl-10 py-2 w-full rounded-md border ${error.area ? 'border-red-300' : 'border-gray-300'} focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500`}
                                                      placeholder="Enter Manager Address"
                                                      value={values.area}
                                                      onChange={handleChange}
                                                    />
                                                  </div>
                                                  {error.area && <p className="mt-1 text-sm text-red-600">{error.area}</p>}
                                                </div>

                                                <div className="form-group">
                                                  <label className="text-sm font-medium text-gray-700 mb-1">Country </label>
                                                  <label className="text-sm font-medium text-red-700">*</label>
                                                  <Select
                                                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); } }}
                                                    options={countryData}
                                                    placeholder="Select work Country"
                                                    onChange={handleGetWorkState}
                                                    className={`react-select-container ${error.selectedworkingCountryId ? 'react-select--error' : ''}`}
                                                    classNamePrefix="react-select"
                                                  />
                                                  {error.selectedworkingCountryId && <p className="mt-1 text-sm text-red-600">{error.selectedworkingCountryId}</p>}
                                                </div>
                                                <div className="form-group">
                                                  <label className="text-sm font-medium text-gray-700 mb-1">State/Province </label>
                                                  <label className="text-sm font-medium text-red-700">*</label>
                                                  <Select
                                                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); } }}
                                                    options={stateData}
                                                    placeholder="Select work State"
                                                    onChange={handleGetWorkCities}
                                                    className={`react-select-container ${error.selectedWorkStateId ? 'react-select--error' : ''}`}
                                                    classNamePrefix="react-select"
                                                  />
                                                  {error.selectedWorkStateId && <p className="mt-1 text-sm text-red-600">{error.selectedWorkStateId}</p>}
                                                </div>
                                                <div className="form-group">
                                                  <label className="text-sm font-medium text-gray-700 mb-1">City </label>
                                                  <label className="text-sm font-medium text-red-700">*</label>
                                                  <Select
                                                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); } }}
                                                    options={cityData}
                                                    placeholder="Select City"
                                                    onChange={handleSetWorkCityId}
                                                    className={`basic-single react-select-container ${error.selectedWorkCityId ? 'react-select--error' : ''}`}
                                                    classNamePrefix="react-select"
                                                  />
                                                  {error.selectedWorkCityId && <p className="mt-1 text-sm text-red-600">{error.selectedWorkCityId}</p>}
                                                </div>
                                                <div className="form-group">
                                                  <label className="text-sm font-medium text-gray-700 mb-1">Work Postal Code </label>
                                                  <label className="text-sm font-medium text-red-700">*</label>
                                                  <div className="relative">
                                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                      <BiMailSend className="text-gray-400" />
                                                    </div>
                                                    <input
                                                      type="text"
                                                      name="workpincode"
                                                      className={`pl-10 py-2 w-full rounded-md border ${error.workpincode ? 'border-red-300' : 'border-gray-300'} focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500`}
                                                      placeholder="Enter Pincode / Zipcode"
                                                      value={values.workpincode}
                                                      onChange={handleChange}
                                                    />
                                                  </div>
                                                  {error.pincode && <p className="mt-1 text-sm text-red-600">{error.workpincode}</p>}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                    <div className='bg-white relative border-[1px] border-solid border-[#e5e5e5] rounded-md my-2'>
                                      <div>
                                        <div className='flex flex-row justify-between items-center py-3 bg-[#e9f3fe]'>
                                          <h5 className="text-black capitalize text-md font-semibold mx-3">Credentials Details </h5>
                                        </div>

                                        <div className="py-5 px-3">
                                          <div className=" space-y-4">
                                            <div className=" rounded-lg  w-full ">
                                              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 text-sm">
                                                {/* Data Section */}
                                                <div className="form-group">
                                                  <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    Password <span className="text-red-700">*</span>
                                                  </label>

                                                  <div className="relative">
                                                    <div className={`flex items-center border-[1px] border-solid ${error.passWord ? 'border-red-300' : 'border-[#c5c5c5]'} rounded-md px-3 py-2 w-full`}>
                                                      <BiLock className="text-gray-400 text-xl mr-2" />

                                                      <input
                                                        type={passwordVisible ? "text" : "password"}
                                                        name="passWord"
                                                        className="w-full text-sm text-gray-700 outline-none py-1"
                                                        placeholder="Enter Manager Password"
                                                        value={values.passWord}
                                                        onChange={handleChange}
                                                      />

                                                      <div
                                                        className="absolute right-3 top-2.5 cursor-pointer"
                                                        onClick={() => setPasswordVisible(!passwordVisible)}
                                                      >
                                                        {passwordVisible ? (
                                                          <FaEyeSlash className="text-gray-400 text-xl" />
                                                        ) : (
                                                          <FaEye className="text-gray-400 text-xl" />
                                                        )}
                                                      </div>
                                                    </div>

                                                    {error.passWord && (
                                                      <p className="mt-1 text-sm text-red-600">{error.passWord}</p>
                                                    )}
                                                  </div>
                                                </div>


                                                <div className="form-group">
                                                  <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    Confirm Password <span className="text-red-700">*</span>
                                                  </label>

                                                  <div className="relative">
                                                    <div className={`flex items-center border-[1px] border-solid ${error.confirmpassword ? 'border-red-300' : 'border-[#c5c5c5]'} rounded-md px-3 py-2 w-full`}>
                                                      <BiLock className="text-gray-400 text-xl mr-2" />

                                                      <input
                                                        type={confirmPasswordVisible ? "text" : "password"}
                                                        name="confirmpassword"
                                                        className="w-full text-sm text-gray-700 outline-none py-1"
                                                        placeholder="Enter Manager Confirm Password"
                                                        value={values.confirmpassword}
                                                        onChange={handleChange}
                                                      />

                                                      <div
                                                        className="absolute right-3 top-2.5 cursor-pointer"
                                                        onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
                                                      >
                                                        {confirmPasswordVisible ? (
                                                          <FaEyeSlash className="text-gray-400 text-xl" />
                                                        ) : (
                                                          <FaEye className="text-gray-400 text-xl" />
                                                        )}
                                                      </div>
                                                    </div>

                                                    {error.confirmpassword && (
                                                      <p className="mt-1 text-sm text-red-600">{error.confirmpassword}</p>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                    <div className="flex justify-end ">
                                      <button type="submit" onClick={handleSubmit} className="px-6 py-3 bg-button-color hover:bg-button-color text-black font-medium rounded-md shadow-sm transition-colors flex items-center gap-2" >
                                        <span>Save User</span>
                                        <FaArrowAltCircleRight className="text-black" />
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div> :
              <div class="col-start-1 col-end-13  my-5 px-3">
                <div class="flex items-start p-3  bg-red-700  border-[1px] border-l-4 border-red-500 rounded-lg relative">
                  <div class="flex-shrink-0 text-white">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="currentcolor" viewBox="0 0 24 24">
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path d="M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm-1 15l-5-5 1.41-1.42L11 14.17l6.59-6.59L19 9z" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <h2 class="text-lg font-semibold text-white">New Purchase Users 🎉</h2>
                    <p class="text-white">A new user has successfully completed a purchase.</p>
                  </div>
             
                </div>
              </div>
            }
          </div>
        ) : (
          <div class="col-start-1 col-end-13  my-5 px-3">
            <div class="flex items-start p-3  bg-red-700  border-[1px] border-l-4 border-red-500 rounded-lg relative">
              <div class="flex-shrink-0 text-white">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="currentcolor" viewBox="0 0 24 24">
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm-1 15l-5-5 1.41-1.42L11 14.17l6.59-6.59L19 9z" />
                </svg>
              </div>
              <div class="ml-3">
                <h2 class="text-lg font-semibold text-white">New Plan Purchased 🎉</h2>
                <p class="text-white">A new Plan has successfully completed a purchase.</p>
              </div>
              <div class="ml-auto">
                <button class="bg-white text-blue-600 font-medium px-4 py-2 rounded-lg border border-blue-600 hover:bg-blue-50 transition"
                  onClick={() => { navigatePlans(type) }}
                >
                  Buy Purchase Plan
                </button></div>
            </div>
          </div>
        )}
      </div>

      <ToastContainer />
    </div>
  );
};

export default AddUser;